
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 35 35","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_b)"}},[_c('circle',{attrs:{"cx":"17.5","cy":"17.5","r":"17.5","fill":"#838DA6"}})]),_c('path',{attrs:{"d":"M9.1 25.9l15.75-15.75M24.85 25.9L9.1 10.15","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_b","x":"-4","y":"-4","width":"43","height":"43","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feGaussianBlur',{attrs:{"in":"SourceGraphic","stdDeviation":"2"}}),_c('feComposite',{attrs:{"in2":"SourceAlpha","operator":"in","result":"effect1_backgroundBlur"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_backgroundBlur","result":"shape"}})])])])
          )
        }
      }
    